import ZH_T from './zh_t'
import ZH_S from './zh_s'
import AR from './ar'
import DE from './de'
import EN from './en'
import FR from './fr'
import JA from './ja'
import KO from './ko'
import RU from './ru'

let defaultLanguage = EN

const i18nTools = {
  LANG: {
    AR,
    DE,
    ZH_S,
    ZH_T,
    EN,
    FR,
    JA,
    KO,
    RU,
  },
  setDefaultLanguage(langList, defaultLang) {
    if (i18nTools.LANG[defaultLang]) {
      defaultLanguage = i18nTools[defaultLang]
    } else if (defaultLang) {
      defaultLanguage = defaultLang
    }
  },
  setDefaultList(langList, defaultLang) {
    // To do
  },
  formatByUA: function (key = '', placeholder) {
    let lang = navigator.language.toLowerCase()
    return this.format(lang, key, placeholder)
  },
  format: function (lang, key = '', placeholder) {
    let source = this.getSource(lang)
    let text = source[key]
    if (placeholder) {
      Object.keys(placeholder).forEach((key) => {
        text = text.replace(`%${key}%`, placeholder[key])
      })
    }
    return text
  },
  getSource: function (lang) {
    let retSource = EN
    let langPrefix = lang.split('-')[0]

    // 根据 language 的前缀走不同的回调逻辑
    switch (langPrefix) {
      // 汉语
      case 'zh':
        // 中文繁体
        if (lang === 'zh-hk' || lang === 'zh-tw') {
          retSource = ZH_T
        } else {
          // 中文简体 'zh' 'zh-CN'
          retSource = ZH_S
        }
        break
      // 日语 'ja' 'ja-jp'
      case 'ja':
        retSource = JA
        break
      // 德语 'de' 'de-de'
      case 'de':
        retSource = DE
        break
      // 韩语 'ko' 'ko-kr'
      case 'ko':
        retSource = KO
        break
      // 法语 'fr-fr'(France) 'fr-ca'(Canada) 'fr-be'(Belgique) 'fr-ch'(Suisse)
      case 'fr':
        retSource = FR
        break
      // 阿拉伯语
      case 'ar':
        retSource = AR
        break
      // 俄语 'ru' 'ru-ru'
      case 'ru':
        retSource = RU
        break
      // 英语
      default:
        retSource = EN
    }

    return retSource
  },
}


export default i18nTools